export default {
    title: 'Status erstellen',
    createStatus: 'Status erstellen',
    createAndEditStatus: 'Erstellen und weiter bearbeiten',
    createStatusSuccess: 'Der Status wurde erfolgreich erstellt.',
    createStatusError: 'Der Status konnte nicht erstellt werden.'
}